const EVENTS = {
  DRAWER_BUTTON_CLICKED: 'drawer-button-clicked',
};

export { EVENTS };
